export default "__VITE_ASSET__BaH0RGic__"